const PT = require("prop-types");
// const React = require("react");
const createReactClass = require("create-react-class");
const WindowResize = require("../util/WindowResize");

// Render props version of withContainerDims. Pass in a render function that
// takes the containerDims object as an argument. This component will rerender
// after each resize of the container.

const getCurrentDims = function(props) {
	if (props.skipOnServer && process.env.IS_NODE) {
		return WindowResize.getEmptyDims();
	} else {
		return WindowResize.getCurrentDims();
	}
};

module.exports = createReactClass({
	displayName: "ContainerDims",

	propTypes: {
		render: PT.func.isRequired,
		skipOnServer: PT.bool,
	},

	getInitialState: function() {
		return {containerDims: getCurrentDims(this.props)};
	},

	statics: {
		getDerivedStateFromProps: function(props) {
			return {containerDims: getCurrentDims(props)};
		},
	},

	componentDidMount: function() {
		this._dimsHandler = newDims => {
			if (this._unmounted) {
				return;
			}
			if (this.state.containerDims !== newDims) {
				this.setState({containerDims: newDims});
			}
		};
		WindowResize.addDimsListener(this._dimsHandler);
	},

	componentWillUnmount: function() {
		// Unsubscribing is not enough on its own; we might unmount this component
		// while handling a resize event that hasn't called our listener yet.
		this._unmounted = true;
		WindowResize.removeDimsListener(this._dimsHandler);
	},

	render: function() {
		return this.props.render(this.state.containerDims);
	},
});
